<template>
  <v-card
    flat
    :color="cardItem.isEnded ? 'rgba(49, 67, 79, 0.2)' : '#31434f'"
    width="250"
    class="container-card"
    @click="detail(false)"
    @click.middle="detail(true)"
  >
    <v-row no-gutters justify="center" align="center" class="card-btns">
      <v-col cols="12">
        <v-btn class="card-btn" plain @click.stop="copyUrlToClipboard">
          <v-icon class="white--text" style="font-size: 16px; font-weight: 500">mdi-link-variant</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" v-if="isMtCreator || isMtOrganizer || isWsManager || isWsOwner" style="padding: 0 !important">
        <v-divider dark style="display: block"></v-divider>
      </v-col>
      <v-col cols="12" v-if="isMtCreator || isMtOrganizer || isWsManager || isWsOwner">
        <v-menu v-model="cardMenu" offset-y left>
          <template v-slot:activator="{ attrs, on }">
            <v-btn plain v-bind="attrs" v-on="on" class="card-btn" style="min-width: 36px">
              <span style="font-size: 16px; font-weight: 500" class="material-icons-round white--text" translate="no">
                {{ cardMenu ? 'close' : 'more_horiz' }}
              </span>
            </v-btn>
          </template>
          <div class="card-menu-comment" style="background-color: #1d292f; overflow: hidden">
            <v-row align="center" justify="center" dense>
              <v-col cols="12">
                <v-btn
                  dark
                  block
                  class=""
                  color="#eee"
                  @click="openDialog('MoveToMeeting')"
                  plain
                  v-if="isMtCreator || isMtOrganizer || isWsManager || isWsOwner"
                >
                  <span
                    class="material-icons-round mr-1"
                    style="color: #ddd; font-size: 18px; font-weight: 400"
                    translate="no"
                  >
                    input
                  </span>
                  {{ 'Move to' }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="isMtCreator || isMtOrganizer || isWsOwner || isWsManager"
                style="padding: 0 !important"
              >
                <v-divider dark style="display: block"></v-divider>
              </v-col>
              <v-col cols="12" v-if="isMtCreator || isMtOrganizer || isWsOwner || isWsManager">
                <v-btn dark block class="" color="#eee" plain @click="openDialog('Delete')">
                  <span
                    class="material-icons-round mr-1"
                    style="color: #ddd; font-size: 18px; font-weight: 400"
                    translate="no"
                  >
                    delete
                  </span>
                  {{ $t('delete') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-menu>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      justify="center"
      align="center"
      v-if="
        isThumbnailLoading &&
        !cardItem.clipThumbsUrl &&
        (cardItem.clipType === 'face' || cardItem.clipType === 'screen')
      "
    >
      <v-progress-circular color="primary" height="10" indeterminate></v-progress-circular>
    </v-row>

    <v-row no-gutters dense justify="center" align="center" v-else style="width: 100%; padding: 4px">
      <div v-if="cardItem.isEnded" class="label-ended mr-1">{{ 'END' }}</div>
      <div v-if="cardItem.mtThumbsUrl || cardItem.clipThumbsUrl" class="container-thumbnail">
        <v-img
          :contain="cardItem.clipType && cardItem.clipType === 'face'"
          :cover="!(cardItem.clipType && cardItem.clipType === 'face')"
          height="155"
          class="thumbnail-img"
          :src="cardItem.mtThumbsUrl || cardItem.clipThumbsUrl"
        />
      </div>

      <div class="text-clip-thumbnail d-flex align-center justify-center" v-else>
        <!-- <v-img v-if="cardItem.clipType === 'embed'" contain height="60" class="thumbnail-empty-logo" :src="embedBg" /> -->
        <span
          v-if="cardItem.clipType === 'embed'"
          class="material-icons-round"
          style="color: white; font-size: 60px"
          translate="no"
        >
          code
        </span>
        <span
          v-else-if="cardItem.clipType === 'poll'"
          class="material-icons-round"
          style="color: white; font-size: 60px"
          translate="no"
        >
          how_to_vote
        </span>
        <!-- <v-img
          v-else-if="cardItem.clipType === 'followUp'"
          contain
          height="60"
          class="thumbnail-empty-logo"
          :src="followupBg"
        /> -->
        <span
          v-else-if="cardItem.clipType === 'followUp'"
          class="material-icons-round"
          style="color: white; font-size: 60px"
          translate="no"
        >
          notifications
        </span>
        <span
          v-else-if="cardItem.clipType === 'text'"
          class="material-icons-round"
          style="color: white; font-size: 60px"
          translate="no"
        >
          title
        </span>
        <v-img
          v-else-if="cardItem.mtClipDuration === undefined || cardItem.mtClipDuration <= 0"
          contain
          height="60"
          class="thumbnail-empty-logo"
          :src="emptyThumbnail"
        />
        <span v-else class="material-icons-round" style="color: white; font-size: 60px" translate="no">mic</span>
        <!-- <p v-else class="text-clip-thumbnail-label">{{ thumbnailText }}</p> -->
        <!-- <v-img v-else contain height="60" class="thumbnail-empty-logo" :src="textBg" /> -->
        <!-- <span v-else class="material-icons-round" style="color: white; font-size: 60px" translate="no">title</span> -->
      </div>
    </v-row>

    <!-- <div class="unread" v-if="cardItem.mtIsUpdate"><b>U</b></div> -->
    <div class="unread" v-if="cardItem.mtIsUpdate"></div>
    <!-- <div class="unread_clip" v-if="cardItem.clipUploader.userId !== userInfo.userId && !cardItem.isWatched">
        <b>N</b>
      </div> -->

    <div class="play-button-outer">
      <div class="play-button"></div>
    </div>

    <v-card-title :style="$vuetify.breakpoint.width < 960 ? 'padding: 10px 16px' : 'padding: 3px 16px'">
      <span class="card-title" :style="cardItem.isEnded ? 'color: #ddd' : 'color: white'">
        {{ cardItem.mtTopic ? cardItem.mtTopic : 'Untitled' }}
      </span>
    </v-card-title>

    <v-card-text class="pb-0">
      <div class="card-sub-title">Started {{ $day.duration($day().diff(cardItem['mtCreatedAt'])).humanize() }} ago</div>
      <div class="card-sub-title">
        <v-icon color="#888" size="22" style="font-size: 22px !important">mdi-vhs</v-icon>
        {{ cardItem.mtClipCount }} {{ cardItem.mtClipCount > 1 ? 'Clips' : 'Clip' }}
        <v-icon color="#888" size="16" style="font-size: 16px !important" class="ml-2">mdi-clock</v-icon>
        {{ calDuration(cardItem.mtClipDuration) }}
      </div>
    </v-card-text>

    <v-card-text class="ml-4 pl-0 pb-0 pt-1">
      <!-- :mtOrganizerUid="cardItem.mtOrganizerUid" -->
      <attendee
        :mtCreatorUid="cardItem.mtCreatedUid"
        :mtOrganizerUid="cardItem.mtCreatedUid"
        :list="cardItem.mtAttendeeList"
        :isAdd="false"
        size="25"
        border="rgb(49, 67, 79)"
        :deleteOrgarnizer="true"
      ></attendee>
    </v-card-text>

    <v-card-subtitle class="d-flex flex-wrap tag-container pt-0 pb-0 pl-4 pr-4">
      <v-chip color="#21343b" :key="tag" height="20" v-for="tag in cardItem.mtHashTag" class="card-tag pl-1 pr-1">
        <span>
          <!-- <span style="color: #999; margin-right: -2px">#</span> -->
          {{ tag }}
        </span>
        <!-- {{ cardItem.mtHashTag && cardItem.mtHashTag.length > 0 ? '#' + cardItem.mtHashTag.join(' #') : '' }} -->
      </v-chip>
    </v-card-subtitle>
    <share-dialog v-if="isShareDialog" @close="closeDialog" :isShareDialog.sync="isShareDialog"></share-dialog>
    <move-to-dialog
      v-if="isMoveToDialog"
      @close="closeDialog"
      :isMoveToDialog.sync="isMoveToDialog"
      :mtInfo.sync="computedItem"
    ></move-to-dialog>
    <meeting-delete-dialog
      v-if="computedItem && isMeetingDeleteDialog"
      @close="closeDialog"
      @result="$emit('result', $event)"
      :mtId="computedItem.mtId"
      :isMeetingDeleteDialog.sync="isMeetingDeleteDialog"
    ></meeting-delete-dialog>
  </v-card>
</template>

<script>
import Attendee from '@/views/meeting/component/card/Attendee'
import { setDurationToTime } from '@/common/lib/strLib'
import audioBg from '@/assets/img/audio-bg-fill.png'
import audioBg2 from '@/assets/img/audio-bg-fill2.png'
import embedBg from '@/assets/img/embed-bg-fill.png'
import followupBg from '@/assets/img/followup-bg-fill.png'
import textBg from '@/assets/img/text-bg-fill.png'
import calendarBg from '@/assets/img/calendar-bg-fill.png'
import emptyThumbnail from '@/assets/img/empty-thumbnail2.png'
import { copy } from '@/common/common'
// import store from '@/store'
import { mapGetters } from 'vuex'
import ShareDialog from '@/views/modal/ShareDialog'
import MeetingDeleteDialog from '@/views/modal/MeetingDeleteDialog'
import MoveToDialog from '@/views/modal/MoveToDialog'
import { getShareUrl, setUserFunnel } from '@/services/api'
import { isSafari } from '@/common/lib/strLib'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'ListCardItem',
  components: {
    Attendee,
    ShareDialog,
    MeetingDeleteDialog,
    MoveToDialog,
  },
  props: ['cardItem'],
  data() {
    return {
      isLogoVisible: false,
      emptyThumbnail: emptyThumbnail,
      audioBg: audioBg,
      audioBg2: audioBg2,
      embedBg: embedBg,
      followupBg: followupBg,
      textBg: textBg,
      calendarBg: calendarBg,
      wsLogo: '',
      path: '',
      duration: 0,
      isThumbnailLoading: false,
      interval: null,
      retryCount: 0,
      isShareDialog: false,
      isMeetingDeleteDialog: false,
      isMoveToDialog: false,
      cardMenu: false,
    }
  },
  created() {
    if (this.isSafari) this.setSafariUrl()
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'selectedWsInfo',
      'currentMt',
      'selectedCh',
      // 'isMtOrganizer',
      // 'isMtCreator',
      'isWsManager',
      'isWsOwner',
    ]),
    isMtOrganizer() {
      let userId = this.userInfo && this.userInfo !== null ? this.userInfo['userId'] : ''
      let mtOrganizerUid = this.cardItem ? this.cardItem.mtOrganizerUid : ''
      return userId !== '' && mtOrganizerUid !== '' && userId === mtOrganizerUid
    },
    isMtCreator() {
      let userId = this.userInfo && this.userInfo !== null ? this.userInfo['userId'] : ''
      let mtCreatedUid = this.cardItem ? this.cardItem['mtCreatedUid'] : ''
      return userId !== '' && mtCreatedUid !== '' && userId === mtCreatedUid
    },
    isSafari() {
      return isSafari()
    },
    thumbnailText() {
      let textClip
      if (this.cardItem && this.cardItem !== null) textClip = this.cardItem.textClip
      if (textClip && textClip !== null && textClip.length > 70) textClip = `${textClip.substring(0, 70)} ...`
      return textClip
    },
    clipTitle() {
      return ''
    },
    clipNote() {
      return ''
    },
    computedItem() {
      return this.cardItem !== undefined && this.cardItem !== null ? this.cardItem : {}
    },
  },
  watch: {
    clipTitle: {
      immediate: true,
      deep: true,
      handler(val) {
        this.cardItem.clipTitle = val
      },
    },
    clipNote: {
      immediate: true,
      deep: true,
      handler(val) {
        this.cardItem.clipNote = val
      },
    },
  },
  methods: {
    async detail(isOpenNewWindow = false) {
      // 미팅에 클립 길이가 0이면 삭제된 클립 에러 처리
      if (this.cardItem.clipDuration === 0) {
        // notify(this, 'Error', 'Deleted Clip', 'error')

        const content = {
          component: Toast,
          props: {
            msg: 'Deleted Clip',
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }

      // 미팅 읽음 로그 기록
      // TODO: 상세 페이지 내 로그 기록과 중복이 아닌지... 리스트를 통한 미팅 클릭 여부 확인이 꼭 필요한 기록인지?

      this.$store.dispatch('setFirebaseLog', {
        eventName: 'view_meeting_detail',
        eventParam: {
          name: 'view_meeting_detail',
        },
      })

      // let subName = ''
      // if (this.$route.name === 'Inbox') subName = 'Inbox'
      // else if (this.$route.name === 'Assigned') subName = 'Assigned'

      // route payload
      let routePayload = {
        name: `ChannelMeetingShare`,
        params: {
          wsDomain: this.selectedWsInfo ? this.selectedWsInfo['wsDomain'] : this.$route.params['wsDomain'],
          // chId: this.selectedCh['chId'].replace('CH:', ''),
          mtId: this.cardItem['mtId'],
        },
      }

      // 새창 여부 확인 후 동작
      if (isOpenNewWindow) {
        let routeData = this.$router.resolve(routePayload)
        window.open(routeData.href, '_blank')
      } else this.$router.push(routePayload).catch(() => {})

      // this.$router.push(`/${this.$route.params['wsDomain']}/share/${this.cardItem['mtId']}`).catch(() => {})
    },
    calDuration(val) {
      return setDurationToTime(val)
    },
    openDialog(type) {
      if (type === 'Share') {
        this.isShareDialog = true
      } else if (type === 'MoveToMeeting') {
        this.isMoveToDialog = true
      } else if (type === 'Delete') {
        this.isMeetingDeleteDialog = true
      }
    },
    closeDialog(val) {
      if (val === 'Share') {
        this.isShareDialog = false
      } else if (val === 'MoveToMeeting') {
        this.isMoveToDialog = false
      } else if (val === 'Delete') {
        this.isMeetingDeleteDialog = false
      }
    },
    async setSafariUrl() {
      let title = this.computedItem.mtTopic
      let imgUrl = this.computedItem.mtThumbsUrl

      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
          mtId: this.computedItem.mtId,
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let content = ''

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)

      this.safariPath = copyUrl.shortLink

      content = this.currentClip.clipNote
      if (this.currentClip.clipThumbsUrl) imgUrl = this.currentClip.clipThumbsUrl
      linkUrl += '?clipId=' + this.currentClip.clipId

      copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.safariPathWithClipId = copyUrl.shortLink
    },
    async copyUrlToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl)
      } else {
        await this.createShareUrl()
        copyResult = await copy(this.path)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: this.clipValue ? 'clip' : 'meeting',
          },
        })
        if (!this.isMobile) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async checkFunnel() {
      if (this.userInfo !== null) {
        try {
          const funnel = this.userInfo.funnel
          if (!funnel || funnel === '' || funnel === 'evaluator') {
            let result = await setUserFunnel(this, 'beginner')
            this.$store.commit('setUserInfo', result)

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'funnel_beginner',
              eventParam: {
                createdAt: Date.now(),
                methodType: 'share_meeting',
              },
            })
          }
        } catch (e) {
          console.log()
        }
      }
    },
    async createShareUrl() {
      let title = this.computedItem.mtTopic
      let imgUrl = this.computedItem.mtThumbsUrl

      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
          mtId: this.computedItem.mtId,
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let content = ''
      if (this.clipValue) {
        content = this.currentClip.clipNote
        if (this.currentClip.clipThumbsUrl) imgUrl = this.currentClip.clipThumbsUrl
        linkUrl += '?clipId=' + this.currentClip.clipId
      }
      // 공유 URL 생성 // TODO: fallbackUrl은 나중에 추가
      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.path = copyUrl.shortLink
    },
  },
}
</script>

<style scoped>
.isPlaying {
  border: solid 5px #ff575f !important;
  min-width: 200px;
  /* margin: -5px; */
}
.v-card--flat {
  box-shadow: 0.5px 0.5px 0 0px #222 !important;
}
.container-card {
  box-shadow: 0.5px 0.5px 0px 0px rgba(33, 33, 33, 0.3) !important;
  border-radius: 10px;
  overflow: hidden;
  min-width: 200px;
}

.v-card--flat .thumbnail-img >>> .v-image__image {
  transition: all 0.5s;
}
.container-thumbnail {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.container-thumbnail >>> .thumbnail-img {
  background-color: #1a272e;
}
.play-list-container-mobile .container-thumbnail .thumbnail-img {
  height: 95px !important;
}

.crown {
  color: #ffc542;
  font-size: 15px;
  position: absolute;
  transform: translateY(-9px);
  margin-left: -24px;
  /* transform: translate(-24px, -9px); */
}

.target {
  white-space: normal;
  line-height: 1.2;
  height: 40px;
  text-align: left;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.tag-container {
  position: relative;
  width: 100%;
  height: 34px;
  display: inline-block;
  word-break: normal;
  overflow: hidden;
  padding: 0px;
  flex-wrap: nowrap;
  margin-top: 8px;
  text-overflow: ellipsis;
}

span.card-tag {
  height: 20px;
  font-size: 11px;
  font-weight: 400;
  color: #bbb;
  padding: 8px;
  margin-right: 4px;
  margin-bottom: 16px;
  line-height: 15px;
  text-overflow: ellipsis;
  border-radius: 5px;
  word-break: normal;
  overflow: hidden;
  border: 1px solid #222;
  letter-spacing: -0.1px;
}

div.deleted-card {
  padding-top: 0px;
  padding-bottom: 2px;
  text-align: center;
  height: 30px;
  display: table;
}
span.deleted-card {
  width: 250px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #96a7af;
  display: table-cell;
  vertical-align: middle;
}

.unread {
  width: 15px;
  height: 15px;
  /* padding: 2px; */
  background-color: #ff575f;
  color: white;
  text-align: center;
  align-self: center;
  font-size: 12px;
  cursor: pointer;
  border: 2px solid rgb(49, 67, 79);
  border-radius: 8px;
  position: absolute;
  top: 10px;
  right: -5px;
  transform: translate(-50%, -50%);
}

.unread_clip {
  width: 22px;
  height: 22px;
  padding: 2px 2px;
  background-color: #ffc542;
  color: white;
  text-align: center;
  align-self: center;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  position: absolute;
  top: 22px;
  right: 2px;
  transform: translate(-50%, -50%);
}

.text-clip-thumbnail {
  width: 100%;
  height: 155px;
  background: #1a272e;
  text-align: center;
  display: table;
  border-radius: 8px;
}

.text-clip-thumbnail-mobile {
  width: 100%;
  height: 100px;
  background: #1a272e;
  text-align: center;
  display: table;
}

.text-clip-thumbnail-label {
  width: 100%;
  color: white;
  max-width: 201.25px;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  max-height: 155px;
  overflow: auto;
}
.v-avatar-name {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
}
.v-card {
  transition: all 0.2s ease-in-out;
}
.label-ended {
  display: inline-block;
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  background-color: #30444e;
  color: #ccc;
  padding: 2px 3.5px 1px 5px;
  border-radius: 5px;
  border: 1px solid #161d21;
}
.container-uploading {
  width: 100%;
  height: 155px;
}
.container-uploading-mobile {
  width: 100%;
  height: 100px;
}

.txt-uploading {
  text-align: center;
  color: white;
}

.card-btns {
  position: absolute;
  bottom: 175px;
  right: 12px;
  z-index: 1;
  display: none;
  border: 1px solid #475e69;
  border-radius: 5px !important;
  overflow: hidden;
  background-color: #161d21;
}

.card-btn {
  width: 30px !important;
  min-width: 0px !important;
  height: 30px !important;
  font-size: 10px !important;
  background-color: #161d21;
}

.card-menu-comment {
  width: 130px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
}
.card-menu-comment >>> .row--dense > .col {
  padding: 4px !important;
}
/* .card-menu-comment >>> .row--dense > .col {
  padding: 0 !important;
} */
.card-menu-comment >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.card-menu-comment >>> button {
  width: 120px;
  justify-content: start;
}

.container-btn-edit >>> button span,
.container-btn-reply >>> button span {
  font-size: 12px;
  font-weight: 400;
}

@media (hover: hover) {
  div.v-card:hover >>> .play-button-outer-mobile {
    opacity: 0.9;
  }
  .v-card--flat:hover {
    box-shadow: 0px 0px 0px 1px #475e69 !important;
    /* transform: translate(-1px, -1px); */
    /* border: 1px solid #475e69; */
  }
  div.v-card:hover >>> .play-button-outer {
    opacity: 0.9;
  }
  .v-card--flat:hover .thumbnail-img >>> .v-image__image {
    transform: scale(1.2);
    transition: all 0.5s;
  }
  .card-menu-comment >>> button:hover {
    /* border: 1px solid #666; */
    background-color: #161d21;
  }
  div.v-card:hover >>> .card-btns {
    display: inline-block;
  }
}
</style>
